// Presents a modal dialog to the user
// Clicking anywhere outside the dialog will call the 'cancelled' callback

import $ from "jquery";
import * as preact from "preact";
import * as _ from "underscore";

import * as deviceDetect from "deviceDetect";

let background,
  stack = [],
  animateTime = 200,
  showDialogTimeout;

const VERTICAL_SPACING = 15; // pixels above and below central dialog

const simpleMode = deviceDetect.is("safari");

const fadeOutBackground = function (backgroundElement, time?: number) {
  if (simpleMode) {
    backgroundElement.stop().fadeOut();
    backgroundElement.remove();
    return;
  }
  backgroundElement.attr("data-anim", "fadeOut");
  setTimeout(function () {
    if (stack.length === 0) {
      backgroundElement.hide();
      backgroundElement.remove();
    }
  }, time || animateTime);
};

const fadeIn = function (element) {
  if (simpleMode) {
    element.stop().fadeIn();
    return;
  }
  if (element.attr("data-anim") !== "fadeIn") {
    element.attr("data-anim", "fadeIn");
    element.css({ "overflow-y": "hidden" });
    element.show();

    const inBookmarklet = /(localhost|readlang.com)\/bookmarklet/.test(
      window.location.href
    );

    setTimeout(
      function () {
        element.css({ "overflow-y": "auto" });
      },
      inBookmarklet ? 400 : animateTime
    );
  }
};

export const cancel = function (event?: any, skipCallback?: boolean) {
  if (stack.length === 0) {
    return;
  }

  if (
    _.last(stack).options.confirmCancelCallback &&
    !_.last(stack).options.confirmCancelCallback()
  ) {
    return;
  }

  const dialog = stack.pop();
  if (dialog.options.cancelCallback && !skipCallback) {
    dialog.options.cancelCallback();
  }
  if (dialog.options.center) {
    dialog.element.remove();
  } else {
    dialog.element.hide();
  }

  if (dialog.options.addToBody && dialog.options.oldParent) {
    dialog.element.css(dialog.options.oldCss);
    dialog.options.oldParent.append(dialog.element);
  }

  if (stack.length === 0) {
    $("body").removeClass("modalNoOverflow");
    fadeOutBackground(background);
    if (requestSpace) {
      requestSpace(0);
    }
  } else {
    const currentElement = _.last(stack).element;
    currentElement.fadeIn(animateTime);
    if (requestSpace) {
      requestSpace(
        (dialog.options.center
          ? 0
          : dialog.element.offset().top + VERTICAL_SPACING) +
          currentElement.outerHeight() +
          VERTICAL_SPACING
      );
    }
  }

  if (event) {
    event.stopPropagation();
  }

  if (dialog.options.view) {
    dialog.options.view.remove();
  }
};

export const cancelAll = function () {
  while (stack.length > 0 && stack[0].options.clickToCancel) {
    cancel();
  }
};

const backgroundClickHandler = (event) => {
  if (stack.some((dialog) => $.contains(dialog.element[0], event.target))) {
    // Don't do anything in this case, since the user is interacting with the modal
    return;
  }

  event.stopPropagation();
  event.preventDefault();

  const dialog = _.last(stack);

  if (!dialog || event.target !== background[0]) {
    return;
  }

  if (dialog.options.clickToCancel) {
    cancel(event);
  }
};

interface DialogOptions {
  clickToCancel?: boolean;
  closeButton?: boolean;
  center?: boolean;
  minHeight?: number;
  create?: boolean;
  heading?: string;
  headingHtml?: string;
  addToBody?: boolean;
  oldParent?: any;
  oldCss?: any;
  view?: any;
  width?: number;
  title?: string;
  fullScreen?: boolean;
  wide?: boolean;
  undoZoom?: boolean;
  /** Returns true to continue cancelling, false to not cancel */
  confirmCancelCallback?: () => boolean;
  cancelCallback?: () => void;
  onShow?: () => void;
}

export const showPreactComponent = function (
  component,
  options?: DialogOptions
) {
  const element = $(`<div/>`);

  // Render the component into the element
  preact.render(component, element[0]);

  show(element, { ...options, create: true });
};

export const show = function (_element, _options?: DialogOptions) {
  // support single options argument containing @param {Backbone.View} view
  if (!_options && _element.view && _element.view.$el) {
    _options = _element;
    _element = _options.view.$el;
  }

  const dialog: {
    options: DialogOptions;
    element: any; // jquery element
  } = {
    options: _.defaults(_options || {}, {
      clickToCancel: true,
      closeButton: true,
      center: true,
      minHeight: 50,
    }),
    element: $(_element).css({
      "z-index": 250,
    }),
  };

  if (dialog.options.create) {
    const inner = dialog.element;
    dialog.element = $(`<div class="centralDialog">`);
    if (dialog.options.heading) {
      dialog.element.append($("<h3>").text(dialog.options.heading));
    } else if (dialog.options.headingHtml) {
      dialog.element.append(dialog.options.headingHtml);
    }
    dialog.element.append(inner);
  }

  if (dialog.options.undoZoom) {
    dialog.element.addClass("undoZoom");
  } else {
    dialog.element.removeClass("undoZoom");
  }

  if (dialog.options.fullScreen) {
    dialog.element.addClass("fullScreen");
  } else {
    dialog.element.removeClass("fullScreen");
  }

  background = $("#modalBackground");
  if (!background || background.length === 0) {
    background = $("<div id=modalBackground/>");
    background.click((event) => backgroundClickHandler(event));
    $("body").append(background);
  }

  if (dialog.options.fullScreen) {
    background.addClass("fullScreen");
  } else {
    background.removeClass("fullScreen");
  }

  if (!dialog.options.title) {
    dialog.options.title = dialog.element.find("h2, h3, p").eq(0).text();
    if (dialog.options.title === "") {
      dialog.options.title = "No-title";
    }
  }

  if (stack.length > 0) {
    _.last(stack).element.hide();
  }
  stack.push(dialog);

  if (dialog.options.closeButton === true) {
    let closeButton = dialog.element.find(".closeDialogButton");

    if (closeButton.length === 0) {
      closeButton = $(
        '<div class=closeDialogButton>&nbsp;<i class="icon icon-remove"></i>&nbsp;</div>'
      ).click((event) => cancel(event));
    }
    dialog.element.append(closeButton);
  }

  if (dialog.options.center) {
    $("body").addClass("modalNoOverflow");
    background.append(dialog.element);
  }

  if (dialog.options.width) {
    dialog.element.css({
      "max-width": dialog.options.width,
      "min-width": dialog.options.width,
      width: dialog.options.width,
      "margin-left": Math.round(-0.5 * dialog.options.width),
    });
  } else if (dialog.options.wide) {
    dialog.element.addClass("wide");
  }

  if (dialog.options.addToBody) {
    dialog.element.css({ opacity: 0 });
    dialog.element.show();

    dialog.options.oldParent = dialog.element.parent();
    dialog.options.oldCss = {
      top: dialog.element.css("top"),
      left: dialog.element.css("left"),
      position: dialog.element.css("position"),
    };

    const top = dialog.element.offset().top;
    const left = dialog.element.offset().left;

    $("body").append(dialog.element);
    dialog.element.css({
      position: "absolute",
      top: top,
      left: left,
      opacity: 1,
    });
  }

  fadeIn(background);

  clearTimeout(showDialogTimeout);
  showDialogTimeout = setTimeout(
    function () {
      // need to show dialog first to get its position
      dialog.element.fadeIn(animateTime);

      const outerDialogHeight = Math.max(
        dialog.options.minHeight,
        dialog.element.outerHeight()
      );

      if (requestSpace) {
        requestSpace(
          (dialog.options.center
            ? 0
            : dialog.element.offset().top + VERTICAL_SPACING) +
            outerDialogHeight +
            VERTICAL_SPACING
        );
      }

      if (dialog.options.onShow) {
        dialog.options.onShow();
      }

      if (dialog.options.view && dialog.options.view.setFocus) {
        dialog.options.view.setFocus();
      }
    },
    // If this delay is too short, we can end up measuring the dialog height incorrectly and not
    // requesting enough vertical space to fit it.
    100
  );
};

const keyDownHandler = function (event) {
  if (
    stack.length > 0 &&
    _.last(stack).options.clickToCancel &&
    event.which === 27
  ) {
    cancel();
  }
};

$(document).ready(function () {
  $(document).keydown(keyDownHandler);
});

let requestSpace;
export const setRequestSpace = function (_requestSpace) {
  requestSpace = _requestSpace;
};

export const isShown = function () {
  return stack.length > 0;
};
